import { Button } from "@/components/ui/button";
import { Heading } from "@/components/ui/Heading";
import { Text } from "@/components/ui/Text";
import type { CreativeLibraryEmptyStateProps } from "@/types/creative-library";
import { CREATIVE_LIBRARY_ICONS } from "./creative-library-visuals";

export function CreativeLibraryEmptyState({
  kind,
  title,
  description,
  actionLabel,
  onCreate,
  hint,
}: CreativeLibraryEmptyStateProps) {
  const Icon = CREATIVE_LIBRARY_ICONS[kind];
  return (
    <div className="flex flex-col items-center gap-4 rounded-2xl border border-dashed border-border px-6 py-12 text-center">
      <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-primary/10 text-primary">
        <Icon className="h-7 w-7" aria-hidden="true" />
      </div>
      <Heading level={3}>{title}</Heading>
      <Text size="sm" color="muted" className="max-w-md">
        {description}
      </Text>
      {hint && (
        <Text size="xs" color="muted" className="max-w-md">
          {hint}
        </Text>
      )}
      {actionLabel && (
        <Button variant="primary" onClick={onCreate}>
          {actionLabel}
        </Button>
      )}
    </div>
  );
}
